import React, { useContext, useRef, useState } from 'react';

import {
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  Popover,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { UserContext } from '../../../../contexts/userContext';
import axiosConfig from 'src/Resources/axiosConfig';
import { FormattedMessage } from 'react-intl';
import { TokenContext } from 'src/contexts/tokenContext';
import { useNavigate } from 'react-router-dom';
import routes from 'src/Resources/routes.json';

import '../../../../App.css';
import { InstallationsContext } from '../../../../contexts/InstallationsContextProvider';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const context = useContext(UserContext);
  const { currentUser, setUser, removeUser } = context;
  const tokencontext = useContext(TokenContext);
  const { token, setNewToken, removeToken } = tokencontext;
  const navigate = useNavigate();
  const { closeSocket } = useContext(InstallationsContext);

  const handleSubmit = () => {
    closeSocket();
    axiosConfig.post('/Logout').then(() => {
      removeToken();
      removeUser();
      localStorage.removeItem('theme');
      navigate(routes.login);
    });
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <div style={{ userSelect: 'none' }}>
      <UserBoxButton
        color="secondary"
        ref={ref}
        onClick={handleOpen}
        style={{ cursor: 'pointer' }}
      >
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser?.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser?.email}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <div style={{ userSelect: 'none', cursor: 'none' }}>
          <MenuUserBox sx={{ minWidth: 210 }} display="flex">
            <UserBoxText>
              <UserBoxLabel variant="body1">{currentUser?.name}</UserBoxLabel>
              <UserBoxDescription variant="body2">
                {currentUser?.email}
              </UserBoxDescription>
            </UserBoxText>
          </MenuUserBox>
        </div>

        <Divider />
        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={handleSubmit}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            <FormattedMessage id="logout" defaultMessage="Logout" />
          </Button>
        </Box>
      </Popover>
    </div>
  );
}

export default HeaderUserbox;
